import { BlockType } from 'api/cms';

import { AccordionBlockMapping } from './Accordion/AccordionBlockMapping';
import { AnchorBlockMapping } from './Anchor/AnchorBlockMapping';
import { BlockMapping, BlockMappingComponentData } from './BlockMapping';
import { BlockquoteBlockMapping } from './Blockquote/BlockquoteBlockMapping';
import { CategoryHighlightBlockMapping } from './CategoryHighlight/CategoryHighlightBlockMapping';
import { CtaHeroBlockMapping } from './CtaHero/CtaHeroBlockMapping';
import { DonateBlockMapping } from './Donate/DonateBlockMapping';
import { EmailCampaignSignupDoubleBlockMapping } from './EmailCampaignSignup/EmailCampaignSignupDoubleBlockMapping';
import { EmailCampaignSignupSingleBlockMapping } from './EmailCampaignSignup/EmailCampaignSignupSingleBlockMapping';
import { FlashCardsQuizBlockMapping } from './FlashCardQuiz/FlashCardsQuizBlockMapping';
import { FormBuilderBlockMapping } from './FormBuilder/FormBuilderBlockMapping';
import { FourArticlesHighlightBlockMapping } from './FourArticlesHighlight/FourArticlesHighlightBlockMapping';
import { FreeCodeBlockMapping } from './FreeCode/FreeCodeBlockMapping';
import { GradCtaHeroBlockMapping } from './GradCtaHero/GradCtaHeroBlockMapping';
import { GradFairGradProgramLinksBlockMapping } from './GradFairGradProgramLinks/GradFairGradProgramLinksBlockMapping';
import { ImageBlockMapping } from './Image/ImageBlockMapping';
import { ImageGalleryBlockMapping } from './ImageGallery/ImageGalleryBlockMapping';
import { PersonaQuizBlockMapping } from './PersonaQuiz/PersonaQuizBlockMapping';
import { RandomGradProgramsBlockMapping } from './RandomGradPrograms/RandomGradProgramsBlockMapping';
import { RecommendedActionsBlockMapping } from './RecommendedActions/RecommendedActionsBlockMapping';
import { RecommendedJobsBlockMapping } from './RecommendedJobs/RecommendedJobsBlockMapping';
import { RichTextBlockMapping } from './RichText/RichTextBlockMapping';
import { ScrollTrackingBlockMapping } from './ScrollTracking/ScrollTrackingBlockMapping';
import { SignUpBlockMapping } from './SignUp/SignUpBlockMapping';
import { SplitContentBlockMapping } from './SplitContent/SplitContentBlockMapping';
import { StickyHeaderLinksBlockMapping } from './StickyHeaderLinks/StickyHeaderLinksBlockMapping';
import { StickyHeaderLinksGradBlockMapping } from './StickyHeaderLinks/StickyHeaderLinksGradBlockMapping';
import { SupportContactFormBlockMapping } from './SupportContactForm/SupportContactFormBlockMapping';
import { ThreeSectionSliderBlockMapping } from './ThreeSectionSlider/ThreeSectionSliderBlockMapping';
import { ThreeStepCtaBlockMapping } from './ThreeStepCta/ThreeStepCtaBlockMapping';
import { TileGridBlockMapping } from './TileGrid/TileGridBlockMapping';
import { TwoTilesBlockMapping } from './TwoTiles/TwoTilesBlockMapping';
import { VideoBlockMapping } from './Video/VideoBlockMapping';

export const blockMappingByType: Record<
  BlockType,
  BlockMapping<BlockMappingComponentData>
> = {
  ACCORDION: AccordionBlockMapping,
  ANCHOR: AnchorBlockMapping,
  BLOCKQUOTE: BlockquoteBlockMapping,
  CATEGORY_HIGHLIGHT: CategoryHighlightBlockMapping,
  CTA_HERO: CtaHeroBlockMapping,
  DONATE: DonateBlockMapping,
  EMAIL_CAMPAIGN_SIGNUP_DOUBLE: EmailCampaignSignupDoubleBlockMapping,
  EMAIL_CAMPAIGN_SIGNUP_SINGLE: EmailCampaignSignupSingleBlockMapping,
  FLASH_CARD_QUIZ: FlashCardsQuizBlockMapping,
  FORM_BUILDER: FormBuilderBlockMapping,
  FOUR_ARTICLES_HIGHLIGHT: FourArticlesHighlightBlockMapping,
  FREE_CODE: FreeCodeBlockMapping,
  GRAD_CTA_HERO: GradCtaHeroBlockMapping,
  GRAD_FAIR_GRAD_PROGRAM_LINKS: GradFairGradProgramLinksBlockMapping,
  IMAGE: ImageBlockMapping,
  IMAGE_GALLERY: ImageGalleryBlockMapping,
  PERSONA_QUIZ: PersonaQuizBlockMapping,
  RANDOM_GRAD_PROGRAMS: RandomGradProgramsBlockMapping,
  RECOMMENDED_ACTIONS: RecommendedActionsBlockMapping,
  RECOMMENDED_JOBS: RecommendedJobsBlockMapping,
  RICHTEXT: RichTextBlockMapping,
  SCROLL_TRACKING: ScrollTrackingBlockMapping,
  SIGN_UP: SignUpBlockMapping,
  SPLIT_CONTENT: SplitContentBlockMapping,
  STICKY_HEADER_LINKS: StickyHeaderLinksBlockMapping,
  STICKY_HEADER_LINKS_GRAD: StickyHeaderLinksGradBlockMapping,
  SUPPORT_CONTACT_FORM: SupportContactFormBlockMapping,
  THREE_SECTION_SLIDER: ThreeSectionSliderBlockMapping,
  THREE_STEP_CTA: ThreeStepCtaBlockMapping,
  TILE_GRID: TileGridBlockMapping,
  TWO_TILES: TwoTilesBlockMapping,
  VIDEO: VideoBlockMapping,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  SCHEDULED_CONTENT: {} as any,
};
